import { withProps } from 'recompose';
import HeaderInner from '../../Header';

const Header = withProps({ product: 'dispositif Denormandie' })(HeaderInner);

export default Header;
